<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>Collection</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col36">
        <h3>Public performance in Brazil</h3>
        <br />
        <p class="ptreze">The ECAD (Central Office for Collection and Distribution), which is an organization that brings together the seven collective management associations for royalties pertaining to music, including UBC, collected a total of BRL 1.106 billion. This is a 3% decrease in relation to 2017.</p>  
        <br />
        <p class="ptreze">The UBC repertoire represents 57% of ECAD's market share based on the total amount distributed by ECAD in 2018.</p>
        <br />
        <span class="titGraf2">Collection of royalties pertaining to public performance in Brazil (ECAD) // Pieces of work and phonograms // In millions (BRL)</span>
        <div class="grafVideo" style="padding:84px 0 0 0;">
        <video style="width:100%;" playsinline autoplay muted>
          <source src="../assets/grafico_arrecadacao_01.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
      </div><!-- col36 -->
      <div class="col36 marginColBottom">
        <h3>UBC royalty collection</h3>
        <br />
        <p class="ptreze">The total amount collected by UBC, including amounts collected via ECAD, collected overseas and pertaining to reproduction rights, equaled BRL 616.8 million.</p>  
        <br />
        <span class="titGraf2">Total amount collected by UBC // On the side: Total collected // In millions of (BRL)<br /></span>
        <div style="width:100%; padding:50px 0 0 0;">
          <video style="width:100%;" playsinline autoplay muted>
            <source src="../assets/grafico_arrecadacao_02.mp4" type="video/mp4"> 
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div><!-- col36 -->
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5">

      </div> 
      <div class="col36 marginColBottom">
      <h3>UBC royalty collection by type of right</h3>
      <div style="width:100%; padding:50px 0 0 0;">
        <video style="width:100%;" playsinline autoplay muted>
          <source src="../assets/grafico_arrecadacao_03.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>  
      </div><!-- col36 -->
      <div class="col36">
        <h3>Collection of rights overseas (by continent)</h3>
          <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_arrecadacao_04.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>  
      </div><!-- col36 -->  
    </section>
  </div>
</div>
</template>

<script>
export default {
  name: 'Arrecadacao',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/Arrecadacao.vue